import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in en.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/en")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
